/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { PetCalloutResponse } from './model/petCalloutResponse';

export const apiPetCalloutResponseCreate = (
  petCalloutResponse: PetCalloutResponse,
  signal?: AbortSignal
) => {
  return HTTP<void>({
    url: `/api/v7/search/pet-callout-response/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: petCalloutResponse,
    signal,
  });
};

export const getApiPetCalloutResponseCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPetCalloutResponseCreate>>,
    TError,
    { data: PetCalloutResponse },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiPetCalloutResponseCreate>>,
  TError,
  { data: PetCalloutResponse },
  TContext
> => {
  const mutationKey = ['apiPetCalloutResponseCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPetCalloutResponseCreate>>,
    { data: PetCalloutResponse }
  > = (props) => {
    const { data } = props ?? {};

    return apiPetCalloutResponseCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiPetCalloutResponseCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPetCalloutResponseCreate>>
>;
export type ApiPetCalloutResponseCreateMutationBody = PetCalloutResponse;
export type ApiPetCalloutResponseCreateMutationError = ErrorType<unknown>;

export const useApiPetCalloutResponseCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPetCalloutResponseCreate>>,
    TError,
    { data: PetCalloutResponse },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiPetCalloutResponseCreate>>,
  TError,
  { data: PetCalloutResponse },
  TContext
> => {
  const mutationOptions = getApiPetCalloutResponseCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
